$(() => {
  const isNative =
    window.navigator.userAgent.toLowerCase().match(/makuake-ios$/i) ||
    window.navigator.userAgent.toLowerCase().match(/makuake-android$/i);
  if (isNative) return;

  const { braze } = window;
  if (!braze) return;

  // パスの処理
  let path = window.location.pathname;
  // 末尾のスラッシュを除去（トップページ以外）
  if (path !== '/' && path.endsWith('/')) {
    path = path.slice(0, -1);
  }
  // トップページの場合は'/'を設定
  if (path === '') {
    path = '/';
  }

  // プロジェクトページの場合は送信しない
  if (path.match(/^\/project\/[^/]+$/)) return;

  // サンキューページの場合は送信しない
  if (path.match(/\/payment\/cf\/thank-you$/)) return;

  // クエリパラメータの処理
  const query = {};
  if (window.location.search) {
    const urlParams = new URLSearchParams(window.location.search);
    Array.from(urlParams.entries()).forEach(([key, value]) => {
      query[key] = value;
    });
  }

  // ハッシュの処理
  const hash = window.location.hash || '';

  // 相対URLの作成
  const href = path + window.location.search + hash;

  braze.logCustomEvent('pageview', { hash, href, path, query });
});
